import { branch, renderComponent } from 'recompose';
import { CompositeComponent } from './types';

export const withPlaceholder = <TProps extends {}>(
    Placeholder: CompositeComponent<any>,
    showPlaceholder: (props: TProps) => boolean
) => branch(showPlaceholder, renderComponent(Placeholder));



// WEBPACK FOOTER //
// ./src/client/components/withPlaceholder.tsx